<template>
  <div
    class="payment-method"
    :class="{ default: defaultMethod }"
    @click="onClick"
    :data-action='defaultMethod ? "select-existing-payment-method" : null'
  >
    <table style="width: 100%;">
      <colgroup>
        <col style="width:50%" />
        <col style="width:25%" />
        <col style="width:25%" />
      </colgroup>
      <tbody>
        <tr>
          <td class="attribute">
            {{ paymentMethod.formatCardType() }}
          </td>
          <td class="attribute">
            {{ paymentMethod.last4 }}
          </td>
          <td class="attribute">{{ paymentMethod.formatExpiration() }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethod',
  components: {},
  props: {
    paymentMethod: {
      type: Object,
      required: true,
    },
    defaultMethod: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$emit('selected', this.paymentMethod)
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.payment-method {
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.4rem;
  cursor: pointer;
  // NIP 9/14/20 Invisible border makes unselected methods line up with selected methods
  border: 2px solid white;
}
.default {
  border: 2px solid var(--dark-brand-color);
  border-radius: 25px;
}
</style>
